import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';

import type { DispositionOptionType } from './types';

const useGetAvailableDispositionOptions = (funnelId?: string) => {
  const [dispositionOptions, setDispositionOptions] = useState<DispositionOptionType[]>([]);
  const [loading, setLoading] = useState(true);

  const getDispositionOptions = async () => {
    setLoading(true);
    try {
      const response = await api.get('/disposition_option/available', {
        params: funnelId ? { funnelId } : undefined,
      });
      setDispositionOptions(response.data);
    } catch (error) {
      toast.error('Erro ao carregar as opções disponíveis. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get available disposition options'), {
        error,
        funnelId,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDispositionOptions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [funnelId]);

  return {
    dispositionOptions,
    loading,
  };
};

export default useGetAvailableDispositionOptions;
